import { render, staticRenderFns } from "./HelicopterBases.vue?vue&type=template&id=31963c50&"
import script from "./HelicopterBases.vue?vue&type=script&lang=js&"
export * from "./HelicopterBases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports